"use strict";

exports.__esModule = true;
exports.DataItemChartSelectorAdaptor = DataItemChartSelectorAdaptor;
var _react = _interopRequireDefault(require("react"));
var _getDeviceDataItemStats = require("../../Device/common/getDeviceDataItemStats");
var _DeviceDataItemStatsSelector = require("../../Device/DeviceDataItemStatsSelector");
var _excluded = ["onChange", "value", "devices", "multiple", "allowedCategories"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function DataItemChartSelectorAdaptor(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    devices = _ref.devices,
    multiple = _ref.multiple,
    allowedCategories = _ref.allowedCategories,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var stats = (0, _getDeviceDataItemStats.getDeviceDataItemStats)(devices, allowedCategories);
  var isDataItemString = typeof value === "string";
  var selectedItem = [];
  if (isDataItemString) {
    var found = value ? stats.find(function (item) {
      return item.dataItemName === value;
    }) : undefined;
    selectedItem = found ? [found] : [];
  } else if (Array.isArray(value)) {
    // Resolve string names to stats objects (popover stores names as strings).
    selectedItem = value.map(function (item) {
      return typeof item === "string" ? stats.find(function (s) {
        return s.dataItemName === item;
      }) : item;
    }).filter(Boolean);
  } else if (value) {
    selectedItem = [value];
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemStatsSelector.DeviceDataItemStatsSelector, _extends({
    onSelect: function onSelect(selected) {
      var next = selected.length > 0 ? isDataItemString ? selected[0].dataItemName : selected : undefined;
      onChange(next);
    },
    selected: selectedItem,
    items: stats,
    multiple: multiple
  }, extra));
}